<template>
	<div class="chat-moment-info">
		<div class="chat-moment-info-nav">
			<span class="chat-moment-info-nav-back"  @click="goBack"></span>
			<span class="chat-moment-info-nav-title">朋友圈详情</span>
		</div>
		<div class="chat-moment-info-wrap">
			<div class="chat-moment-info-item">
				<div class="chat-moment-info-avater">
					<img :src="moment.senderPhoto | connectHost" alt="">
				</div>
				<div class="chat-moment-info-detail">
					<div class="chat-moment-info-name">
						<p>{{moment.senderName}}</p>
					</div>
					<div class="chat-moment-info-text" v-html="$options.filters.formatMsg(moment.content,'text')">
					</div>
					<div class="chat-moment-info-extra">
						<div class="chat-moment-info-pics" v-if="moment.type == 1 && moment.pics.length > 0">
							<div class="chat-moment-info-pics-wrap" v-for="(pic,index) in moment.pics">
								<img :src="pic" alt="" @click="preview(moment.pics,'image',index)">
							</div>
						</div>
						<div class="chat-moment-info-video" v-else-if="moment.type == 2">
							<img :src="moment.video.videoPic" alt="">
							<span class="chat-moment-info-v-play"  @click="preview(moment.video,'video',0)"></span>
						</div>
						<div class="chat-moment-info-link" v-else-if="moment.type == 3">
							<div class="chat-moment-info-l-avater">
								<img :src="moment.link.linkImg" alt="">
							</div>
							<div class="chat-moment-info-l-text">
								<p>{{moment.link.linkText}}</p>
							</div>
						</div>
					</div>
					<div class="chat-moment-info-tools">
						<div class="chat-moment-info-t-time">
							{{moment.time | rechentDate}}
						</div>
						<div class="chat-moment-info-t-other">
							<div class="chat-moment-info-t-item">
								<p @click="replyComment(1)"><span class="chat-moment-info-t-zan"></span><i>点赞</i></p>
								<p @click="showComment()"><span class="chat-moment-info-t-comment"></span><i>评论</i></p>
							</div>
						</div>
					</div>
					<div class="chat-moment-info-zan-box">
						<div class="chat-moment-info-zan-icon"></div>
						<div class="chat-moment-info-zan-item">
							<img :src="photoList[fabulou.dzWxid] | connectHost" alt="" v-for="fabulou in moment.fabulous">
						</div>
					</div>
					<div class="chat-moment-info-comment-box">
						<div class="chat-moment-info-comment-icon"></div>
						<div class="chat-moment-info-comment-items">
							<div class="chat-moment-info-comment-item" v-for="(comment,c_index) in moment.comments">
								<div class="chat-moment-info-comment-avatar">
									<img :src="photoList[comment.commentUserWxid] | connectHost" alt="">
								</div>
								<div class="chat-moment-info-comment-info">
									<div class="chat-moment-info-comment-desc">
										<p class="chat-moment-icd-name" @click="commentFansClick(c_index,comment.commentUserWxid)">{{comment.commentUser}}</p>
										<p class="chat-moment-icd-time">{{comment.time}}</p>
									</div>
									<div class="chat-moment-info-comment-content">
										<p class="chat-moment-icc-reply" v-if="comment.commentToWxid !== ''">回复<span>{{comment.commentToUser}}</span>：</p>
										<p class="chat-moment-icc-text" v-html="$options.filters.formatMsg(comment.commentText,'text')"></p>
									</div>
								</div>
								<div class="chat-moment-info-c-opts" v-if="comment.showOpt">
									<ul>
										<li @click="goChatting(comment.commentUserWxid)">聊天</li>
										<li @click="showComment(comment.commentId,comment.commentUserWxid,comment.commentUser,c_index)">评论</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					<div class="chat-moment-info-add-comment">
						<div class="chat-moment-info-ac-input">
							<textarea v-model="addMoment" :placeholder="argued.argued_open_id !== '' ? '回复'+argued.argued_name+'：' : ''" id="chat-moment-info-ac-input"></textarea>
						</div>
						<div class="chat-moment-info-ac-opts">
							<span class="chat-moment-info-ac-emoji" @click="showAddMEmoji()"></span>
							<span class="chat-moment-info-ac-send" @click="replyComment(2)">评论</span>
						</div>
						<div class="chat-moment-info-ac-emoji-show" v-if="showEmoji">
							<emoji @emoji-call="emojiCall($event)"></emoji>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {pushMomentsReply} from '../socket/socketEventSender.js'
	import {webMomentsReplySave,webGetMomentReplyList} from '../network/web/moments.js'
	import Emoji from './Emoji.vue'
	import {getFansByWxid} from '../network/local/friend.js'
	import {getCustomByWxid,getCustomById} from '../network/local/custom.js'
	import {getCurrentTime} from '../functions/Common.js'

	export default {
		name: 'ChatMomentInfo',
		components: {
			Emoji
		},
		props: {
			moments: {
				type: Object,
				default: function() {
					return {}
				}
			}
		},
		data() {
			return {
				showEmoji: false,
				addMoment:'',
				argued:{
					commentId:'0',
					argued_open_id: '',
					argued_name: ''
				},
				moment:{},
				photoList:{},
				custom: {}
			}
		},
		computed: {
			momentData() {
				return this.$store.state.otherEvent
			}
		},

		methods: {
			// 初始化基本数据
			init() {
				this.showEmoji = false
				this.moment = {}
				this.photoList = {}
				this.custom = {}
			},
			// 初始化评论和点赞数据
			initComment() {
				this.argued = {
					commentId: '0',
					argued_open_id: '',
					argued_name: ''
				}
				this.addMoment = ""
			},

			// 评论中粉丝昵称点击处理
			commentFansClick(commentIndex, userWxid) {
				if(userWxid === this.custom.open_id){
					return
				}
				for (let i = 0; i < this.moment.comments.length; i++) {
					if (i !== commentIndex) {
						this.moment.comments[i].showOpt = false
					}
				}
				this.moment.comments[commentIndex].showOpt = !this.moment.comments[commentIndex].showOpt
			},

			/**
			 * 评论按钮点击-展示和隐藏评论页面
			 * @param {Object} commentId 评论id
			 * @param {Object} argued_open_id 准备回复的粉丝wxid
			 * @param {Object} argued_name 准备回复的粉丝昵称
			 * @param {Object} c_index 当前朋友圈的评论索引值
			 */
			showComment(commentId, argued_open_id, argued_name, c_index) {
				if (c_index !== undefined) {
					this.moment.comments[c_index].showOpt = false
				}
				if (commentId !== undefined && commentId != '0') {
					this.argued.argued_open_id = argued_open_id
					this.argued.argued_name = argued_name
					this.argued.commentId = commentId
				} else {
					this.argued.argued_open_id = ''
					this.argued.argued_name = ''
					this.argued.commentId = '0'
				}
				document.getElementById('chat-moment-info-ac-input').focus()
			},

			// 评论页面-表情点击-表情页面的显示和隐藏
			showAddMEmoji() {
				this.showEmoji = !this.showEmoji
			},

			// 表情点击回调
			emojiCall(data) {
				this.addMoment += '[' + data.title + ']'
				this.showEmoji = false
			},

			// 发表评论/点赞
			replyComment(snsType) {
				if (this.addMoment === "" && snsType === 2) {
					CHAT_LAYER.msg("评论内容不能为空", {
						icon: 2
					})
					return
				}
				if (this.moment.snsid === undefined || this.moment.snsid === "") {
					CHAT_LAYER.msg("snsId为空", {
						icon: 2
					})
					return
				}
				let content = this.addMoment
				let account_comment_id = '0'
				let argued_open_id = ''
				let argued_name = ''
				if (snsType == 1) {
					content = ''
					// 判断是否点赞过
					let fabulous = this.moment.fabulous
					if (fabulous.length > 0) {
						for (let i = 0; i < fabulous.length; i++) {
							if (fabulous[i].dzWxid === this.custom.open_id || fabulous[i].dzWxid === this.custom.open_id) {
								CHAT_LAYER.msg("不能重复点赞", {
									icon: 2
								})
								return
							}
						}
					}
				} else if (snsType == 2) {
					argued_open_id = this.argued.argued_open_id
					argued_name = this.argued.argued_name
					account_comment_id = this.argued.commentId
				}
				let data = {
					account_open_id: this.custom.open_id,
					account_name: this.custom.wx_name,
					friend_open_id: this.moment.senderWxid,
					friend_name: this.moment.senderName,
					account_sns_id: this.moment.snsid,
					content: content,
					account_comment_id: account_comment_id,
					argued_open_id: argued_open_id,
					argued_name: argued_name
				}
				webMomentsReplySave(data, (res) => {
					if (res) {
						if (snsType == 2) {
							// 界面评论显示
							this.moment.comments.push({
								commentId: 0,
								commentUser: data.account_name,
								commentUserWxid: data.account_open_id,
								commentText: data.content,
								commentToWxid: data.argued_open_id,
								commentToUser: data.argued_name,
								time: getCurrentTime(),
								showOpt: false
							})
							this.addMoment = ""
						} else if (snsType == 1) {
							this.moment.fabulous.push({
								dzName: data.account_name,
								dzWxid: data.account_open_id
							})
						}
						// 推送socket事件
						let phone_id = this.custom.phone_id !== undefined ? this.custom.phone_id : this.friend.phone_id
						pushMomentsReply(phone_id, snsType, data)
						// 设置头像列表
						if(this.photoList[this.custom.open_id] === undefined){
							this.$set(this.photoList,this.custom.open_id,this.custom.wx_photo)
						}
					}
				})
			},
			
			// 渲染朋友圈详细信息
			getDetail(){
				let data = JSON.parse(JSON.stringify(this.moments))
				// 获取客服信息或粉丝信息
				if(data.commentMyself == 1){
					getCustomByWxid(data.openId,res=>{
						if(res.id !== undefined){
							data.senderName = res.wx_name
							data.senderPhoto = res.wx_photo
							data.senderWxid = res.open_id
						}	
						this.getComments(data)
					})
				}else{
					getFansByWxid(data.openId,res=>{
						if(res.id !== undefined){
							data.senderName = res.wx_name
							data.senderPhoto = res.wx_photo
							data.senderWxid = res.open_id
							
						}
						this.getComments(data)
					})
				}
				// 获取客服信息
				getCustomById(data.customId,c_res=>{
					this.custom = c_res
				})
			},
			
			// 获取评论列表
			getComments(data){
				webGetMomentReplyList(data.snsid,reply=>{
					// 处理评论和点赞
					let comments = []
					let fabulous = []
					if(reply !== false){
						if(reply.length > 0){
							for (let i = 0; i < reply.length; i++) {
								// 点赞
								if(reply[i].content === ''){
									fabulous.push({
										dzName: reply[i].friend_name,
										dzWxid: reply[i].friend_open_id
									})
								}
								// 评论
								else{
									let commentToWxid = ''
									let commentToUser = ''
									if( reply[i].argued_open_id !== null &&  reply[i].argued_open_id !== "null"){
										 commentToWxid = reply[i].argued_open_id
									}
									if(reply[i].argued_name !== null &&  reply[i].argued_name !== "null"){
										 commentToUser = reply[i].argued_name
									}
									comments.push({
										commentId: reply[i].account_comment_id,
										commentUser: reply[i].friend_name,
										commentUserWxid: reply[i].friend_open_id,
										commentText: reply[i].content,
										commentToWxid: commentToWxid,
										commentToUser: commentToUser,
										time: reply[i].create_time,
										showOpt: false
									})
								}	
								// 获取头像集合
								this.getPhoto(data,reply[i].friend_open_id)
							}
						}
					}
					data.comments = comments
					data.fabulous = fabulous
					this.moment = data
				})
			},
			
			//获取头像集合
			getPhoto(data,wxid){
				if(this.photoList[wxid] === undefined){
					// 判断是否为发圈人自己
					if(data.senderWxid == wxid){
						this.$set(this.photoList,wxid,data.senderPhoto)
					}else{
						getFansByWxid(wxid,res=>{
							if(res.id !== undefined){
								this.$set(this.photoList,wxid,res.wx_photo)
							}
						})
					}	
				}
			},
			
			// 图片或视频预览点击处理
			preview(content,type,index){
				if(type === 'image'){
					if(!content instanceof Array){
						return
					}
					let imgList = content
					if(imgList.length === 0){
						return
					}
					this.$store.commit('updatePreviewFile',{
						 type:'image',
						 data:imgList,
						 index: parseInt(index)
					})
				}else if(type === 'video'){
					let videoData = {
						url: content.videoUrl,
						thumbUrl: content.videoPic
					}
					this.$store.commit('updatePreviewFile',{
						 type:'video',
						 data:videoData,
						 index: parseInt(index)
					})
				}
			},
			
			// 返回上一页
			goBack(){
				this.$emit('chat-m-msg-back','msg')
			},
			
			// 跳转聊天页面
			goChatting(wxid){
				let query = {
					c_id: this.custom.id,
					c_wxid: this.custom.open_id,
					f_wxid: wxid,
					type: 'fans'
				}
				this.$router.push({
					path: '/chat/chat',
					query:query
				})
			},
		},
		created() {
			this.getDetail()
		}
	}
</script>

<style>
	.chat-moment-info {
		width: 100%;
		height: 100%;
		position: relative;
		overflow-x: hidden;
	}

	.chat-moment-info .chat-moment-info-nav {
		height: 30px;
		line-height: 30px;
		border-bottom: 1px solid #e3e3e3;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}

	.chat-moment-info-nav>span {
		display: block;
	}

	.chat-moment-info-nav .chat-moment-info-nav-back {
		width: 40px;
		height: 30px;
		cursor: pointer;
		background-image: url(../assets/img/back-8a-32.png);
		background-position: center;
		background-repeat: no-repeat;
		background-size: auto 16px;
	}

	.chat-moment-info-nav .chat-moment-info-nav-title {
		flex-grow: 1;
		width: 0;
		text-align: center;
		color: #8a8a8a;
	}

	.chat-moment-info-wrap {
		position: absolute;
		top: 31px;
		bottom: 0;
		width: 100%;
		overflow-x: hidden;
		overflow-y: auto;
	}

	.chat-moment-info-item {
		padding: 10px 20px;
		width: 100%;
		height: auto;
		min-height: 100px;
		display: flex;
		justify-content: flex-start;
		flex-wrap: nowrap;
		box-sizing: border-box;
	}

	.chat-moment-info-item .chat-moment-info-avater {
		width: 44px;
		height: 44px;
		margin-right: 6px;
	}

	.chat-moment-info-avater img {
		width: 100%;
		height: 100%;
		border-radius: 4px;
	}

	.chat-moment-info-item .chat-moment-info-detail {
		width: 0;
		flex-grow: 1;
	}

	.chat-moment-info-detail .chat-moment-info-name {
		height: 24px;
		line-height: 24px;
		font-weight: bold;
		color: #225f8c;
	}

	.chat-moment-info-detail .chat-moment-info-text {
		padding: 5px 0;
		line-height: 20px;
	}

	.chat-moment-info-detail .chat-moment-info-extra {
		width: 100%;
		height: auto;
		overflow: hidden;
	}

	.chat-moment-info-extra .chat-moment-info-pics {
		width: 100%;
		max-width: 400px;
		padding: 5px 0;
		height: auto;
		display: flex;
		flex-wrap: wrap;
		justify-content: flex-start;
		align-items: flex-start;
	}

	.chat-moment-info-pics .chat-moment-info-pics-wrap {
		width: 32%;
		position: relative;
		height: 0;
		padding-bottom: 32%;
		margin: 1px;
	}

	.chat-moment-info-pics-wrap img {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		cursor: pointer;
		box-shadow: 0 0 1px 0 #5d5d5d;
	}

	.chat-moment-info-extra .chat-moment-info-video {
		width: 80%;
		max-width: 200px;
		height: auto;
		position: relative;
		padding: 5px 0;
	}

	.chat-moment-info-video img {
		width: 100%;
		height: auto;
		min-height: 80px;
		background-color: #3e3e3e;
	}

	.chat-moment-info-video .chat-moment-info-v-play {
		width: 30px;
		height: 30px;
		display: block;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		background-image: url(../../public/img/video_play.png);
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;
		cursor: pointer;
	}

	.chat-moment-info-extra .chat-moment-info-link {
		width: 100%;
		height: 50px;
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		justify-content: flex-start;
		overflow: hidden;
		background-color: #EEEEEE;
		padding: 5px;
		box-sizing: border-box;
		cursor: pointer;
		font-size: 12px;
	}

	.chat-moment-info-link .chat-moment-info-l-avater {
		width: 40px;
		height: 40px;
		overflow: hidden;
		margin-right: 5px;
	}

	.chat-moment-info-l-avater img {
		width: 100%;
		height: 100%;
		border-radius: 2px;
		background-color: #3e3e3e;
	}

	.chat-moment-info-link .chat-moment-info-l-text {
		width: 0;
		flex-grow: 1;
		height: 40px;
		overflow: hidden;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}

	.chat-moment-info-l-text p {
		display: block;
		line-height: 20px;
		max-height: 40px;
		overflow: hidden;
	}

	.chat-moment-info-extra .chat-moment-info-music {
		width: 100%;
		height: 50px;
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		justify-content: flex-start;
		overflow: hidden;
		background-color: #EEEEEE;
		padding: 5px;
		box-sizing: border-box;
		cursor: pointer;
	}

	.chat-moment-info-music .chat-moment-info-m-avater {
		width: 40px;
		height: 40px;
		overflow: hidden;
		margin-right: 5px;
		position: relative;
	}

	.chat-moment-info-m-avater img {
		width: 100%;
		height: 100%;
		border-radius: 2px;
		background-color: #3e3e3e;
	}

	.chat-moment-info-m-avater .chat-moment-info-m-play {
		width: 20px;
		height: 20px;
		display: block;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		background-image: url(../../public/img/video_play.png);
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;
	}

	.chat-moment-info-music .chat-moment-info-m-text {
		width: 0;
		flex-grow: 1;
		height: 40px;
		overflow: hidden;
	}

	.chat-moment-info-m-text p {
		display: block;
		width: 100%;
		line-height: 20px;
		height: 20px;
		overflow: hidden;
		font-size: 12px;
	}

	.chat-moment-info-m-text p:first-child {
		font-size: 13px;
		color: #225f8c;
	}

	.chat-moment-info-detail .chat-moment-info-tools {
		display: flex;
		justify-content: space-between;
		flex-wrap: nowrap;
		width: 100%;
		height: 30px;
		line-height: 30px;
		font-size: 13px;
	}

	.chat-moment-info-tools .chat-moment-info-t-time {
		color: #888888;
	}

	.chat-moment-info-tools .chat-moment-info-t-other {
		width: 0;
		flex-grow: 1;
	}

	.chat-moment-info-t-other .chat-moment-info-t-item {
		display: flex;
		justify-content: flex-end;
		flex-wrap: nowrap;
		width: 100%;
		height: 30px;
		line-height: 30px;
	}

	.chat-moment-info-t-item p {
		display: block;
		padding-left: 8px;
		cursor: pointer;
	}

	.chat-moment-info-t-item p span {
		width: 14px;
		height: 14px;
		display: inline-block;
		background-position: center;
		background-repeat: no-repeat;
		background-size: 14px auto;
		vertical-align: middle;
		margin-right: 2px;
	}

	.chat-moment-info-t-item .chat-moment-info-t-reload {
		background-image: url(../assets/img/comp-m-reload.png);
	}

	.chat-moment-info-t-item .chat-moment-info-t-zan {
		background-image: url(../assets/img/comp-m-zan.png);
	}

	.chat-moment-info-t-item .chat-moment-info-t-comment {
		background-image: url(../assets/img/comp-m-comment.png);
	}

	.chat-moment-info-t-item p i {
		display: inline-block;
		vertical-align: middle;
		font-style: unset;
	}
	.chat-moment-info-zan-box{
		margin-top: 5px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		background-color: #EEEEEE;
		padding: 5px;
	}
	.chat-moment-info-zan-box .chat-moment-info-zan-icon{
		width: 20px;
		height: 20px;
		background-image: url(../assets/img/comp-m-zan.png);
		background-position: center;
		background-repeat: no-repeat;
		background-size: 16px auto;
		margin-right: 5px;
	}
	.chat-moment-info-zan-box .chat-moment-info-zan-item{
		flex-grow: 1;
		width: 0;
	}
	.chat-moment-info-zan-item img{
		width: 30px;
		height: 30px;
		border-radius: 2px;
		margin:2px;
		cursor: pointer;
	}
	.chat-moment-info-comment-box{
		margin-top: 1px;
		display: flex;
		justify-content: flex-start;
		align-items: flex-start;
		background-color: #EEEEEE;
		padding: 5px;
	}
	.chat-moment-info-comment-box .chat-moment-info-comment-icon{
		width: 20px;
		height: 20px;
		background-image: url(../assets/img/comp-m-comment.png);
		background-position: center;
		background-repeat: no-repeat;
		background-size: 16px auto;
		margin-right: 5px;
	}
	.chat-moment-info-comment-box .chat-moment-info-comment-items{
		flex-grow: 1;
		width: 0;
	}
	.chat-moment-info-comment-item{
		padding: 3px 0;
		display: flex;
		justify-content: flex-start;
		align-items: flex-start;
		margin-bottom: 5px;
		position: relative;
	}
	.chat-moment-info-comment-item .chat-moment-info-comment-avatar{
		width: 30px;
		height: 30px;
		margin-right: 5px;
	}
	.chat-moment-info-comment-avatar img{
		width: 100%;
		height: 100%;
		border-radius: 2px;
	}
	.chat-moment-info-comment-item .chat-moment-info-comment-info{
		flex-grow: 1;
		width: 0;
	}
	.chat-moment-info-comment-info .chat-moment-info-comment-desc{
		display: flex;
		justify-content: space-between;
		align-items: center;
		line-height: 20px;
	}
	.chat-moment-info-comment-desc .chat-moment-icd-name{
		color: #225f8c;
		font-size: 12px;
		font-weight: bold;
		cursor: pointer;
	}
	.chat-moment-info-comment-desc .chat-moment-icd-time{
		font-size: 12px;
		color: #888888;
	}
	.chat-moment-info-comment-info .chat-moment-info-comment-content{
		min-height: 20px;
		line-height: 20px;
		font-size: 12px;
	}
	.chat-moment-info-comment-content > p{
		display: inline-block;
		color: #888888;
	}
	.chat-moment-info-comment-content .chat-moment-icc-reply span{
		color: #225f8c;
		font-weight: bold;
	}
	.chat-moment-info-comment-item .chat-moment-info-c-opts{
		position: absolute;
		width: 100px;
		height: auto;
		top: -66px;
		left: 36px;
		background-color: #212121;
		z-index: 1;
		padding: 5px 5px;
		line-height: 26px;
		color: #FFFFFF;
		border-radius: 2px;
		text-indent: 5px;
	}
	.chat-moment-info-comment-item .chat-moment-info-c-opts::after{
		display: block;
		content: '';
		position: absolute;
		bottom: -5px;
		left: 10px;
		width: 10px;
		height: 10px;
		background-color: #212121;
		transform: rotateZ(45deg);
	}
	.chat-moment-info-c-opts li{
		cursor: pointer;
	}
	.chat-moment-info-c-opts li:hover{
		background-color: #414141; 
	}
	.chat-moment-info-detail .chat-moment-info-add-comment{
		margin: 5px 0;
		position: relative;
	}
	.chat-moment-info-add-comment .chat-moment-info-ac-input{
		height: 70px;
		overflow: hidden;
	}
	.chat-moment-info-ac-input textarea{
		height: 70px;
		width: 100%;
		border: 1px solid #e3e3e3;
		padding: 5px;
		box-sizing: border-box;
		line-height: 18px;
		resize: none;
		border-radius: 4px;
		color: #888888;
	}
	.chat-moment-info-ac-input textarea:focus{
		border: 1px solid #009688;
	}
	.chat-moment-info-add-comment .chat-moment-info-ac-opts{
		width: 100%;
		margin-top: 5px;
		height: 22px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.chat-moment-info-ac-opts span{
		display: block;
		user-select: none;
		height: 22px;
		line-height: 22px;
		cursor: pointer;
	}
	.chat-moment-info-ac-opts .chat-moment-info-ac-emoji{
		width: 22px;
		background-image: url(../assets/img/comp-c-tools-emoji.png);
		background-position: center;
		background-size: 22px auto;
	}
	.chat-moment-info-ac-opts .chat-moment-info-ac-send{
		background-color: #1178b5;
		padding: 0 5px;
		color: #FFFFFF;
	}
	.chat-moment-info-add-comment .chat-moment-info-ac-emoji-show{
		position: absolute;
		width: 405px;
		height: 200px;
		max-width: 100%;
		bottom: 32px;
		left: -5px;
	}
</style>
